import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { ProductivityInsertService } from '../../service/productivity-insert/productivity-insert.service';

@Component({
	selector: 'app-productivity-insert',
	templateUrl: './productivity-insert.component.html',
	providers: [
		ProductivityInsertService,
		HttpModule
	]
})
export class ProductivityInsertComponent implements OnInit {

	private token;
	prodForm: FormGroup;
	Nome: string = "";
	statusProd: boolean;
	public allRegions: any[] = [];
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private productivityInsertService: ProductivityInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.prodForm = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Regiao': [this.allRegions[0], Validators.required],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.productivityInsertService.getRegion(this.token).subscribe(result => {
			this.allRegions = result.Result;
		}, error => {
			console.log(error);
			
		})
	}

	addProductivity(value: any) {

		var objProd = {
			Nome: value.Nome,
			Ativo: value.Ativo,
			RegiaoID: value.Regiao,
			Regiao: []
		};

		var ListRegion = this.allRegions.filter(opt => opt.checked).map(opt=>opt.ID);
		for(let obj of ListRegion) {
			objProd.Regiao.push({ ID: obj.toString() })
		}

		this.productivityInsertService.insertProductivity(this.token, objProd).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Produtividade Média cadastrada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/produtividade-media');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/produtividade-media');
	}

}


// WEBPACK FOOTER //
// ./src/app/productivity/component/productivity-insert/productivity-insert.component.ts